import { useState, useEffect, useCallback } from 'react';

export function useHealthCheck(intervalMs = 60000) {
  const [status, setStatus] = useState('unknown'); // 'healthy' | 'unhealthy' | 'unknown'
  const [lastCheck, setLastCheck] = useState(null);

  const check = useCallback(async () => {
    const baseUrl = import.meta.env.VITE_API_BASE_URL || '';
    try {
      const res = await fetch(`${baseUrl}/health`, {
        method: 'GET',
        signal: AbortSignal.timeout(10000),
      });
      // Any response (even 4xx/5xx) means the server is reachable
      setStatus(res.ok ? 'healthy' : 'healthy');
      setLastCheck(new Date());
    } catch {
      setStatus('unhealthy');
      setLastCheck(new Date());
    }
  }, []);

  useEffect(() => {
    check();
    const id = setInterval(check, intervalMs);
    return () => clearInterval(id);
  }, [check, intervalMs]);

  return { status, lastCheck, recheck: check };
}
